import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { truncate } from 'lodash';
import { useMediaQuery } from '@material-ui/core';

import Card from '../../main/containers/channel/CardColourfulBold';
import ImageDrop from '../../main/components/ImageDrop/ImageDropChannels';
import SvgIcon from '../../main/components/SvgIcon';
import {
  COLOURFUL_TEMPLATE_NAME,
  IMAGE_ASPECT_RATIO_CH_COLOURFUN,
  IMAGE_ASPECT_RATIO_ONE,
} from '../../main/utils/const';
import SectionHeaderWeb from '../../main/components/SectionHeaderWeb';
import { getColorDependsOnBackground } from '../../main/utils/helpers/getColorDependsOnBackground';
import { getImageAspectRatio } from '../../main/utils/helpers/getImageAspectRatio';

const Channels = ({
  locales,
  locales: {
    portfolioWeb,
    channel: {
      intro: { card },
    },
  },
  firstSvgColor,
  secondSvgColor,
  buttonBackgroundColor,
  background,
  backgroundImage,
  isFourthColorPaletteNumber = false,
}) => {
  const [activeCardId, setActiveCardId] = useState(null);
  const { channels } = useSelector((state) => state.portfolio);
  const { collection } = useSelector((state) => state.channel);

  const activeCardData = useMemo(() => {
    if (collection.length && !activeCardId) {
      setActiveCardId(collection[0].id);
      return collection[0];
    }
    return collection.find((i) => i.id === activeCardId);
  }, [collection, activeCardId]);

  const isSmallDesktop = useMediaQuery('(max-width: 1024px)');

  const singleCard = activeCardData && (
    <Card
      locales={locales}
      isPreview
      card={{
        ...card,
        ...activeCardData,
        title: null,
      }}
    />
  );

  const singleImage = activeCardData && (
    <ImageDrop
      locales={locales}
      backgroundImage={backgroundImage}
      titleImageColor={
        isFourthColorPaletteNumber &&
        getColorDependsOnBackground(backgroundImage)
      }
      templateName={COLOURFUL_TEMPLATE_NAME}
      editMode={false}
      aspectRatio={getImageAspectRatio(
        isSmallDesktop,
        IMAGE_ASPECT_RATIO_ONE,
        IMAGE_ASPECT_RATIO_CH_COLOURFUN,
      )}
      card={{
        ...card,
        ...activeCardData,
        title: null,
      }}
    />
  );

  return (
    <div className="channel-colourful-web">
      <div className="left" style={{ backgroundColor: background }}>
        <div className="svg-funChannelsFirst" style={{ fill: firstSvgColor }}>
          <SvgIcon name="funChannelsFirst" />
        </div>
        <div className="svg-funChannelsSecond" style={{ fill: secondSvgColor }}>
          <SvgIcon name="funChannelsSecond" />
        </div>
        {singleImage}
      </div>
      <div className="right">
        <SectionHeaderWeb
          templateName={COLOURFUL_TEMPLATE_NAME}
          title={portfolioWeb.channels}
          description={channels.description}
          portfolioWeb={portfolioWeb}
        />

        <div className="cards-section">
          <div className="tabs">
            {collection.map(({ id, name }) => (
              <div
                key={id}
                onClick={() => setActiveCardId(id)}
                className={classnames(
                  'item',
                  {
                    active: activeCardId === id,
                  },
                  'custom-font-body',
                )}
                style={{
                  backgroundColor: activeCardId === id && buttonBackgroundColor,
                  color:
                    activeCardId === id &&
                    isFourthColorPaletteNumber &&
                    getColorDependsOnBackground(buttonBackgroundColor),
                }}
              >
                {truncate(name, { length: 30 })}
              </div>
            ))}
          </div>
          <div className="main">{singleCard}</div>
        </div>
      </div>
    </div>
  );
};

export default Channels;
